/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
// @flow

import { createBrowserHistory } from 'history';
import { mixpanelV3Helper } from 'src/helpers/mixpanel-v3';

const createHistory = createBrowserHistory();

createHistory.listen((location, action) => {
  window.scrollTo(0, 0);
});

process.env.NODE_ENV !== 'development' &&
  createHistory.listen((location, action) => {
    // Tracking event
    mixpanelV3Helper.trackEventData('View Page', {
      pagePath: location.pathname === '/' ? '/home' : location.pathname
    });
  });

export default createHistory;
